export function datetimeFormat(dateTime) {
    if (dateTime !== undefined && dateTime !== null) {
        var Y = dateTime.slice(0, 4) + "/";
        var M = dateTime.slice(4, 6) + "/";
        var D = dateTime.slice(6, 8) + " ";
        var h = dateTime.slice(8, 10) + ":";
        var m = dateTime.slice(10, 12) + ":";
        var s = dateTime.slice(12, 14);

        return Y + M + D;
    } else {
        return dateTime
    }
}

export function datetimeFormat1(dateTime) {
    if (dateTime !== undefined && dateTime !== null) {
        var Y = dateTime.slice(0, 4) + "/";
        var M = dateTime.slice(4, 6) + "/";
        var D = dateTime.slice(6, 8) + " ";
        var h = dateTime.slice(8, 10) + ":";
        var m = dateTime.slice(10, 12) + ":";
        var s = dateTime.slice(12, 14);

        return Y + M + D + h + m + s;
    } else {
        return dateTime
    }
}

export function formatTelcomEquipmentNumber(equipmentNumber) {
    // Reference: https://www.ncc.gov.tw/chinese/files/07051/497_972_070517_1.pdf
    if (equipmentNumber == null) {
        return equipmentNumber;
    }
    var formatedEquipementNumber = equipmentNumber;
    if (equipmentNumber.length === 10 && equipmentNumber.startsWith('09')) { //手機
        formatedEquipementNumber = equipmentNumber.substr(0, 4) + ' ' + equipmentNumber.substr(4);
    } else if (equipmentNumber.length >= 9 && equipmentNumber.length <= 10) {
        if (equipmentNumber.startsWith('0826')) { //烏坵
            formatedEquipementNumber = equipmentNumber.substr(0, 4) + ' ' + equipmentNumber.substr(4);
        } else if (equipmentNumber.startsWith('082')) { //金門
            formatedEquipementNumber = equipmentNumber.substr(0, 3) + ' ' + equipmentNumber.substr(3, 3) + ' ' + equipmentNumber.substr(6) ;
        } else if (equipmentNumber.startsWith('0836')) { //馬祖
            formatedEquipementNumber = equipmentNumber.substr(0, 4) + ' ' + equipmentNumber.substr(4);
        } else if (equipmentNumber.startsWith('069')) { //澎湖縣
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 3) + ' ' + equipmentNumber.substr(5) ;
        } else if (equipmentNumber.startsWith('089')) { //台東縣
            formatedEquipementNumber = equipmentNumber.substr(0, 3) + ' ' + equipmentNumber.substr(3, 3) + ' ' + equipmentNumber.substr(6) ;
        } else if (equipmentNumber.startsWith('08')) { //屏東縣
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 3) + ' ' + equipmentNumber.substr(5) ;
        } else if (equipmentNumber.startsWith('07')) { //高雄縣市
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 3) + ' ' + equipmentNumber.substr(5) ;
        } else if (equipmentNumber.startsWith('06')) { //台南縣市
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 3) + ' ' + equipmentNumber.substr(5) ;
        } else if (equipmentNumber.startsWith('05')) { //雲林/嘉義
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 3) + ' ' + equipmentNumber.substr(5) ;
        } else if (equipmentNumber.startsWith('049')) { //南投縣
            formatedEquipementNumber = equipmentNumber.substr(0, 3) + ' ' + equipmentNumber.substr(3, 3) + ' ' + equipmentNumber.substr(6) ;
        } else if (equipmentNumber.startsWith('047') || equipmentNumber.startsWith('048')) { //彰化縣
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 3) + ' ' + equipmentNumber.substr(5) ;
        } else if (equipmentNumber.startsWith('04')) { //台中縣市
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 4) + ' ' + equipmentNumber.substr(6) ;
        } else if (equipmentNumber.startsWith('037')) { //苗栗縣
            formatedEquipementNumber = equipmentNumber.substr(0, 3) + ' ' + equipmentNumber.substr(3, 3) + ' ' + equipmentNumber.substr(6) ;
        } else if (equipmentNumber.startsWith('03')) { //花蓮縣/宜蘭縣/新竹縣市/桃園縣
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 3) + ' ' + equipmentNumber.substr(5) ;
        } else if (equipmentNumber.startsWith('02')) { //台中縣市
            formatedEquipementNumber = equipmentNumber.substr(0, 2) + ' ' + equipmentNumber.substr(2, 4) + ' ' + equipmentNumber.substr(6) ;
        } 
    }


    return formatedEquipementNumber;
}
